<div class="checkout-group">
  <div class="checkout-group-title">
    {{ 'checkout.group.payment.title' | cxTranslate }}
  </div>
  @if (paymentModes) {
  <form [formGroup]="paymentModeForm">
    <div class="checkout-group-body d-flex">
      <!-- Payment Mode Dropdown-->
      <div class="payment-group-info payment-group-info-dropdown">
        <mat-form-field appearance="outline" class="mat-primary mat-form-field">
          <mat-label>{{ 'checkout.group.payment.paymentModeTitle' | cxTranslate }}</mat-label>
          <mat-select
            appearance="outline"
            formControlName="paymentMode"
            disableOptionCentering
            panelClass="checkout-select"
            (selectionChange)="onSelectPayment()"
          >
            @for (mode of paymentModes; track mode) {
            <mat-option [value]="mode">
              {{ mode.name }}
            </mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
      <!-- Payment Terms -->
      <div class="payment-group-info">
        <span class="payment-title">{{ 'checkout.group.payment.paymentModeTerms' | cxTranslate }}</span>
        <span class="payment-value">{{ paymentTerms }}</span>
      </div>
    </div>
  </form>
  }
</div>
